import { useQuery } from "@tanstack/react-query";
import { CloudForwarderForwarders } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const FORWARDERS_CONFIGURATION_QUERY_KEY = "forwarders_configuration_hostname";
const DEFAULT_DATA = {};
const getConfiguration = async () => CloudForwarderForwarders.getConfiguration();
const useForwardersConfiguration = () => {
  const { data: responseData, isLoading } = useQuery({
    queryKey: [FORWARDERS_CONFIGURATION_QUERY_KEY],
    queryFn: () => defaultOnError(
      getConfiguration(),
      `Loading Forwarders configuration failed with status`,
      `Could not load Forwarders configuration`
    )
  });
  return {
    data: responseData != null ? responseData : DEFAULT_DATA,
    isLoading
  };
};
export default useForwardersConfiguration;
